module.exports = Qua;

function Qua(qua) {
    this.reset();
    if (typeof qua == "string") {
        this.parseQua(qua);
    } else {
        if (typeof qua != "undefined") {
            //console.error("qua type error, type = " + typeof qua);
        }
    }
}
//相关字段含义请参照qua2协议.doc
Qua.prototype.reset = function() {
    this.softType = "";                           //软件类型 :WX|QQ|QB|QBX|QZ|TRD|TOS|EMUI|TBS
    this.platForm = "";                           //平台:ADR|AP|I|IP|WP|WIN|MAC
    this.subPlatForm = "";                      //子平台
    this.machine ="";                            //机型
    //内核
    this.coreName = "";                       //内核名称:等同QUA2的CO字段;QUA2-2:IMTT:iOS系统内核
    this.coreVersion = "";                    //内核版本,等同QUA2-2中的COVN, QUA2-3的COVC
    //QB/TBS版本
    this.version = 0;                   //版本号，只适用QB/TBS版本，其他的为0，通过sParentPackageVN判断版本
    this.subVersion = "";                       //子版本，只适用QB/TBS版本，其他的空，通过sParentPackageVN判断版本
    this.betaVersion = -1;                               //beta版本号//B1|B2|B3.....
    this.build = -1;                            //【主版本】【子版本】[build]
    this.lcId = -1;                       // LC ID
    this.channel = -1;                 //渠道号
    this.isUa = false;                             //是否从UA解析:true:是，false:否
    //屏幕
    this.width = -1;                                  //屏幕宽度
    this.height = -1;                                 //屏幕高度
    //操作系统
    this.os = -1;                                   //操作系统版本4.4，会忽略操作系统版本号的最后一位，建议使用sOsVersion
    this.osVersion = "";                      //操作系统版本号4.4.2
    //QUA2增加字段
    this.quaVesion = -1;             //QUA版本号0:QUA版本2:QUA2-2版本3:QUA2-3版本
    this.productBranch = "";               //产品分支，等同QUA2的PB字段:(GE)|PAD|TV|INT|TMS
    this.product = "";                         //产品标识，等同QUA2的PR字段:WX|QQ|QB|QZ|TRD|TOS|EMUI
    this.parentPackage = "";              //母版本包，等同QUA2的PP字段:com.tencent.mm|com.tencent.mqq
    this.parentPackageVC = -1; //母版本号，等同于QUA2-2版本的PPVC字段，QUA2-3已经不存在，使用该字段需要判断iQuaVesion==2
    this.parentPackageVN = "";         //母版本号，字符串比较大小, 非QB/TBS版本使用该字段判断版本号；等同QUA2-3中的PPVN
    this.tbsVN = "";                          //TBS版本，字符串比较大小等同QUA2-3中的TBSVC
    this.device = "";                          //设备屏幕(PHONE)|PAD|TV
    this.api = "";                      //安卓版本API-LEVEL，13|17
    this.keyValue = {};
};

Qua.prototype.parseUa = function(ua) {
    if (typeof ua != "string") {
        //console.error('ua type error, type = ' + typeof ua);
        return false;
    }
    var tempUa = ua.toLowerCase();
    var mqqIndex = tempUa.indexOf("mqqbrowser");
    if (mqqIndex != -1) {
        this.reset();
        this.isUa = true;
        if (tempUa.indexOf("android") != -1) {
            this.platForm = "ADR";
            this.subPlatForm = "ADR";
        }
        if (tempUa.indexOf("iphone") != -1) {
            this.platForm = "I";
            this.subPlatForm = "IPH";
        }

        var mqqUa = tempUa.substr(mqqIndex);
        var verStr = mqqUa.substr(mqqUa.indexOf("/") + 1, 3);
        this.version = parseFloat(verStr, 10);
        if (this.version < 10) {
            this.version *= 10;
        }

        //console.log("[parseUa] platForm : " , this.platForm, ", version : " , this.version);
        return true;
    } else {
        return false;
    }
};

Qua.prototype.parseQua1 = function(qua) {
    if (typeof qua != "string") {
        //console.error('qua type error, type = ' + typeof qua);
        return false;
    }
    var value = qua.split('&');
    if (value.length < 5 ) {
        //console.error('qua1 length error, qua = ' + qua);
        return false;
    }

    this.reset();

    var wh = value[3];
    if (wh && wh.length >= 6) {
        this.width = parseInt(wh.substr(0,2) * 16, 10) || -1;
        this.height = parseInt(wh.substr(2,2) * 16, 10) || -1;
    }

    this.machine = value[4].trim();
    var softInfo = value[0];
    var siArray = softInfo.split('/');

    var  bulid = siArray[1];
    this.build = parseInt(bulid, 10) || -1;
    if (typeof this.build != "number") {
        this.build = 0;
    }

    var snInfo = siArray[0].split('_');
    //ADRQB24
    var softName = snInfo[0].toUpperCase();
    if (softName.indexOf("QB") != -1) {
        this.platForm = softName.substr(0, softName.indexOf("QB"));
        var verStr = softName.substr(softName.length - 2);
        this.version = parseInt(verStr, 10) || 0;
        this.softType = softName.substr(softName.indexOf("QB"), softName.length - this.platForm.length
            - verStr.length);
    } else if (softName.indexOf("QQ") != -1) {
        this.platForm = softName.substr(0, softName.indexOf("QQ"));
        var posIndex = softName.indexOf("QQ") + 2;
        if (softName.length > posIndex) {
            var verStr = softName.substr(posIndex);
            this.version = parseInt(verStr, 10) || 0;
            this.softType = "QQ";
        }
    }

    if (snInfo.length > 1) {
        this.subVersion = snInfo[1];
        if (this.subVersion && this.subVersion.length > 1) {
            if (this.subVersion.substr(0,1).toUpperCase() == "B") {
                this.betaVersion = parseInt(this.subVersion.substr(1), 10) || -1;
            }
        }
    }

    this.subPlatForm = value[2];

    if (value[value.length - 1].toUpperCase() == "V3") {
        if (value.length > 7) {
            this.channel = parseInt(value[5], 10) || -1;
            this.lcId =  parseInt(value[6], 10) || -1;
            if (this.platForm == "ADR" && value.length == 9) {
                this.os = value[7];
                if (this.os.length > 10) {
                    this.os = parseFloat(this.os.substr(7,3)) || -1;
                } else {
                    this.os = parseFloat(this.os) || -1;
                }

                var prefix = "Android";
                var index = (this.os + "").indexOf(prefix);
                if (index != -1) {
                    this.osVersion = (this.os + "").substr(index + prefix.length,
                        this.os.length - index - prefix.length);
                }
            }
        }

    }

    var core = value[1].split('/');
    if (core.length == 2) {
        this.coreName = core[0].trim();
        this.coreVersion = core[1].trim();
    } else {
        this.coreName = "";
        this.coreVersion = "";
    }

    //console.log("parseQua1 : " + this.toString());
    return true;
};

Qua.prototype.parseQua2 = function(qua) {
    //QUA2解析
    if (typeof qua != "string") {
        //('qua type error, type = ' + typeof qua);
        return false;
    }
    this.reset();
    var array = qua.split('&');
    for (var i = 0, l = array.length; i < l; ++i) {
        var iter = array[i];
        var hash = iter.split('=');
        if (hash.length != 2) {
            var errMsg = "parseQua2 err, qua=" + qua;
            //throw new Error(errMsg);
            //console.error(errMsg);
            return false;
        }

        this.keyValue[hash[0]] = hash[1];
    }
    this.quaVersion = this.keyValue['QV'];
    //QUA2-3版本解析
    if (this.quaVersion == 2) {
        return this.parseQua22(this.keyValue);
    } else if (this.quaVersion == 3) {
        return this.parseQua23(this.keyValue);
    } else {
        var errMsg = "quaVersion error, quaVersion = " + this.quaVersion;
        //console.error(errMsg);
        //throw new Error(errMsg);
        return false;
    }
};

Qua.prototype.parseQua22 = function(keyValue) {
    if (typeof keyValue != "object") {
        return false;
    }
    //coreName
    this.coreName = keyValue['CO'];
    //coreVersion
    this.coreVersion = keyValue['COVN'];
    //device
    this.device = keyValue['DE'];
    //softType
    var st = keyValue['PR'];
    if (st) {
        if (st == 'QB' && this.coreName == 'X5') {
            this.softType = "QBX";
        } else {
            this.softType = st;
        }
    }
    //platForm
    var pf = keyValue['PL'];
    if (pf) {
        this.platForm = pf;
        if (pf == 'ADR') {
            this.subPlatForm = 'ADR';
            if (this.device == 'PAD') {
                this.platForm = 'AP';
                this.subPlatForm = 'AP';
            }
        } else if (pf == 'IOS') {
            this.platForm = 'I';
            this.subPlatForm = 'IPH';
            if (this.device == 'PAD') {
                this.platForm = 'IP';
                this.subPlatForm = 'IP';
            }
        } else {
            this.subPlatForm = pf;
        }
    }
    //machine
    var mo = keyValue['MO'];
    if (mo) {
        this.machine = mo.trim();
    }
    //version
    var vs = keyValue['VN'];
    if (vs) {
        var vsArray = vs.split('.');
        if (vsArray.length != 4) {
            var errMsg = "parseQua22 err, VN=" + vs;
            //throw new Error(errMsg);
            //console.error(errMsg);
            return false;
        }

        var version = vsArray[0] + vsArray[1];
        //为了兼容老版本，TES/TBS版本号增加80
        if ((this.softType == "TES") || (this.softType == "TBS")) {
            this.version = (parseInt(version, 10) || 0) + 80;
        } else {
            this.version = parseInt(version, 10) || 0;
        }

        var build = this.version + vsArray[3];
        this.build = parseInt(build, 10) || -1;
    }

    //subVersion
    var sv = keyValue["VE"];
    if (sv) {
        this.subVersion = sv;
        if (sv && sv.length > 1) {
            if (sv.substr(0,1).toUpperCase() == "B") {
                this.betaVersion = parseInt(sv.substr(1), 10) || -1;
            }
        }
    }

    //lcId
    var lcId = keyValue["LCID"];
    this.lcId = parseInt(lcId, 10) || -1;

    //channel
    var channel = keyValue["CHID"];
    this.channel = parseInt(channel, 10) || -1;

    //width, height
    var wh = keyValue["RL"];
    if (wh) {
        var whArray = wh.split('*');
        if (whArray.length != 2) {
            var errMsg = "parseQua22 err, RL= " + wh;
            //throw new Error(errMsg);
            //console.error(errMsg);
            return false;
        }
        this.width = parseInt(whArray[0], 10) || -1;
        this.height = parseInt(whArray[1], 10) || -1;
    }

    //os
    var os = keyValue['OS'];
    if (os)  {
        this.os = parseFloat(os) || -1;
        this.osVersion = os;
    }

    //productBranch
    var pb = keyValue['PB'];
    if (pb) {
        this.productBranch = pb;
    }

    //parentPackage
    var pp = keyValue['PP'];
    if (pp) {
        this.parentPackage = pp;
    }

    //parentPackageVC
    var ppvc = keyValue["PPVC"];
    if (ppvc) {
        this.parentPackageVC = parseInt(ppvc, 10) || -1;
    }

    //api
    var api = keyValue["API"];
    if (api) {
        this.api = parseInt(api, 10);
    }

    //console.log("parseQua22 : " + this.toString());
    return true;
};

Qua.prototype.parseQua23 = function(keyValue) {
    if (typeof keyValue != "object") {
        return false;
    }
    //product
    var product = keyValue["PR"];
    if (product) {
        this.product = product;
    }

    //parentPackage
    var pp = keyValue["PP"];
    if (pp) {
        this.parentPackage = pp;
    }

    //parentPackageVN
    var ppvn =  keyValue["PPVN"];
    if (ppvn) {
        this.parentPackageVN = ppvn;
        //QB\TBS\TES满足4段式版本
        if ((this.product == "QB") || (this.product == "TBS") || (this.product == "TES")) {
            var value = ppvn.split('.');
            if (value.length != 4) {
                var errMsg = "parseQua23 err, product = " + this.product + ", PPVN = " + ppvn;
                //throw new Error(errMsg);
                //console.error(errMsg);
                return false;
            }
            var version = value[0] + value[1];
            //为了兼容老版本，TES/TBS版本号增加80
            if ((this.softType == "TES") || (this.softType == "TBS")) {
                this.version = (parseInt(version, 10) || 0) + 80;
            } else {
                this.version = parseInt(version, 10) || 0;
            }

            var build = this.version + value[3];
            this.build = parseInt(build, 10) || -1;
        }
    }

    //tbsVN
    var tbsVN = keyValue["TBSVC"];
    if (tbsVN) {
        this.tbsVN = tbsVN;
    }

    //coreName
    var cn = keyValue["CO"];
    if (cn) {
        this.coreName = cn;
    }

    //coreVersion
    var cv = keyValue["COVC"];
    if (cv) {
        this.coreVersion = cv;
    }

    //softType
    var st = keyValue["PR"];
    if (st) {
        this.softType = st;
        if (st == "QB" && ((this.coreName == "WK") || (this.coreName == "BK"))) {
            this.softType = "QBX";
        }
    }

    //platForm
    var pf = keyValue["PL"];
    if (pf) {
        this.platForm = pf;
        if (pf == "ADR") {
            this.subPlatForm = "ADR";
            //IPAD
            if (this.device == "PAD") {
                this.platForm = "AP";
                this.subPlatForm = "AP";
            }
        } else if (pf == "IOS") {
            this.platForm = "I";
            this.subPlatForm = "IPH";
            //IPAD
            if (this.device == "PAD") {
                this.platForm = "IP";
                this.subPlatForm = "IP";
            }
        } else {
            this.subPlatForm = pf;
        }
    }

    //channel
    var channel = keyValue["CHID"];
    this.channel = parseInt(channel, 10) || -1;

    //lcId
    var lcId = keyValue["LCID"];
    this.lcId = parseInt(lcId, 10) || -1;

    //width,height
    var wh = keyValue["RL"];
    if (wh) {
        var value = wh.split('*');
        if (value.length != 2) {
            var errMsg = "parseQua23 err, RL = " + wh;
            //throw new Error(errMsg);
            //console.error(errMsg);
            return false;
        }
        this.width = parseInt(value[0], 10) || -1;
        this.height = parseInt(value[1], 10) || -1;
    }

    //machine
    var machine = keyValue["MO"];
    if (machine) {
        this.machine = machine.trim();
    }

    //productBranch
    var pb = keyValue["PB"];
    if (pb) {
        this.productBranch = pb;
    }

    //device屏幕
    var de = keyValue["DE"];
    if (de) {
        this.device = de;
    }

    //subVersion
    var sv = keyValue["VE"];
    if (sv) {
        this.subVersion = sv;
        if (sv && typeof sv == "string" && sv.length > 1) {
            //B1|B2|B3.....
            if (sv.substr(0,1).toUpperCase() == "B") {
                this.betaVersion = parseInt(sv.substr(1), 10);
            }
        }
    }

    //osVersion
    var os = keyValue["OS"];
    if (os) {
        this.os = parseFloat(os) || -1;
        this.osVersion = os;
    }

    //api
    var api = keyValue["API"];
    if (api) {
        this.api = parseInt(api, 10) || -1;
    }

    //console.log("parseQua23 : " + this.toString());

    return true;
};

Qua.prototype.parseQua = function(qua) {
    try {
        if (qua.indexOf("=") != -1) {
            return this.parseQua2(qua);
        } else if ((qua + '').split('&').length >= 5) {
            return this.parseQua1(qua);
        } else {
            return this.parseUa(qua);
        }

    } catch (e) {
        var errMsg = "parse qua exception : " + e.message;
        //console.error(errMsg);
        //throw new Error(errMsg);
        return false;
    }

    return true;
};

Qua.prototype.parseQuaOrUa = function(qua, ua) {
    if (!qua || typeof qua != 'string' || qua.indexOf("&") == -1) {
        return this.parseUa(ua);
    } else {
        this.parseQua(qua);
    }
};

Qua.prototype.parse = function(qua1, qua2, ua) {
    if (!qua1 && !qua2) {
        return this.parseUa(ua);
    }

    try {
        //QUA解析
        if (!qua2) {
            return this.parseQua1(qua1);
        } else {
            return this.parseQua2(qua2);
        }

    } catch (e) {
        var errMsg = "parse qua exception : " + e.message;
        //console.error("parse qua exception:" , e.message);
        return false;
    }

    return true;
};

Qua.prototype.getValueByKey = function(key) {
    return this.keyValue[key] || "";
};

//用户WUP下发IP和域名判断
Qua.prototype.isAndroidHighVersionForWup = function() {
    if (this.platForm == "ADR") {
        //QUA2版本都是高版本
        if (this.quaVesion > 0) {
            return true;
        } else {
            if (this.version > 51) {
                return true;
            } else if ((this.version == 51) && (this.build >= 510795)) {
                return true;
            } else {
                return false;
            }
        }
    }

    return false;
};

Qua.prototype.getSoftType = function() {
    return this.softType || "";
};

Qua.prototype.getPlatform = function() {
    return this.platForm || "";
};

Qua.prototype.getSubPlatForm = function() {
    return this.subPlatForm || "";
};

Qua.prototype.getMachine = function() {
    return this.machine || "";
};

Qua.prototype.getCoreName = function() {
    return this.coreName || "";
};

Qua.prototype.getCoreVersion = function() {
    return this.coreVersion || "";
};

Qua.prototype.getVersion = function() {
    return this.version || 0;
};

Qua.prototype.getSubVersion = function() {
    return this.subVersion || "";
};

Qua.prototype.getBetaVersion = function() {
    return this.betaVersion || -1;
};

Qua.prototype.getBuild = function() {
    return this.build || -1;
};

Qua.prototype.getLcId = function() {
    return this.lcId || -1;
};

Qua.prototype.getChannel = function() {
    return this.channel || -1;
};

Qua.prototype.isFromUa = function() {
    return this.isUa || false;
};

Qua.prototype.getWidth = function() {
    return this.width || -1;
};

Qua.prototype.getHeight = function() {
    return this.height || -1;
};

Qua.prototype.getOs = function() {
    return this.os || -1;
};

Qua.prototype.getOsVersion = function() {
    return this.osVersion || "";
};

Qua.prototype.getQuaVesion = function() {
    return this.quaVersion || -1;
};

Qua.prototype.getProductBranch = function() {
    return this.productBranch || "";
};

Qua.prototype.getProduct = function() {
    return this.product || "";
};

Qua.prototype.getParentPackage = function() {
    return this.parentPackage || "";
};

Qua.prototype.getParentPackageVC = function() {
    return this.parentPackageVC || "";
};

Qua.prototype.getParentPackageVN = function() {
    return this.parentPackageVN || "";
};

Qua.prototype.getTbsVN = function() {
    return this.tbsVN || "";
};

Qua.prototype.getDevice = function() {
    return this.device || "";
};

Qua.prototype.getApi = function() {
    return this.api || "";
};

Qua.prototype.getKeyValue = function() {
    return this.keyValue || {};
};


Qua.prototype.toString = function() {
    var ret = this.softType
        + '|' + this.platForm
        + '|' + this.subPlatForm
        + '|' + this.machine
        + '|' + this.coreName
        + '|' + this.coreVersion
        + '|' + this.version
        + '|' + this.subVersion
        + '|' + this.betaVersion
        + '|' + this.build
        + '|' + this.lcId
        + '|' + this.channel
        + '|' + this.isUa
        + '|' + this.width
        + '|' + this.height
        + '|' + this.os
        + '|' + this.osVersion
        + '|' + this.quaVesion
        + '|' + this.productBranch
        + '|' + this.product
        + '|' + this.parentPackage
        + '|' + this.parentPackageVC
        + '|' + this.parentPackageVN
        + '|' + this.tbsVN
        + '|' + this.device
        + '|' + this.api;
    for (var i in this.keyValue) {
        ret = ret + '|' + (this.keyValue[i] || "")
    }
    return ret;
};
